"use client"

import { Button } from '@/app/components/ui/button';
import { DrawerContent, Drawer, DrawerTrigger } from '@/app/components/material/drawer';
import { Input } from '@/app/components/ui/input';
import { AuctionFilterContext, FilterType } from '@/lib/context/AuctionFilterContext';
import { Flex, Text } from '@radix-ui/themes';
import React, { useContext, useState } from 'react';
import { constructBudgetLabel, parseBudget } from '@/lib/utils';
import { X } from 'lucide-react';

const BudgetFilter = () => {
  const auctionFilterContext = useContext(AuctionFilterContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [budgetMin, setBudgetMin] = useState<string | undefined>(undefined);
  const [budgetMax, setBudgetMax] = useState<string | undefined>(undefined);

  const handleOpenChange = (val: boolean) => {
    if (val) {
      const cachedBudgetFilterLabel = auctionFilterContext
        ?.getFiltersOfType(FilterType.BUDGET)
        ?.map(f => f.label)[0]
        || '';

      if (cachedBudgetFilterLabel) {
        const { min: bmin, max: bmax } = parseBudget(cachedBudgetFilterLabel);
        setBudgetMin(bmin !== undefined ? bmin.toString() : undefined);
        setBudgetMax(bmax !== undefined ? bmax.toString() : undefined);
      } else {
        setBudgetMin(undefined);
        setBudgetMax(undefined);
      }
    }

    setDrawerOpen(val)
  }

  const filterByBidAmount = () => {
    const label = constructBudgetLabel(budgetMin, budgetMax);

    if (label) {
      const filter = {
        label,
        type: FilterType.BUDGET
      };

      auctionFilterContext?.updateFiltersOfType(
        [filter],
        FilterType.BUDGET
      );
    } else {
      auctionFilterContext?.deleteFiltersOfType(FilterType.BUDGET)
    }
  };

  const clearFields = () => {
    setBudgetMin('');
    setBudgetMax('');
  }

  return (
    <Drawer
      direction="right"
      open={drawerOpen}
      onOpenChange={handleOpenChange}
    >
      <DrawerTrigger asChild>
        <Button variant="outline" className="rounded-none h-11">
          Budget
        </Button>
      </DrawerTrigger>
      <DrawerContent className="py-4 px-5 min-w-72">
        <Flex direction="column" className="w-full h-full">
          <Flex justify="between" align="center" className="w-full h-12 px-3">
            <Button className="invisible">
              <X className="w-4 h-4" />
            </Button>
            <Text className="text-lg font-semibold leading-none">
              Bid Amount
            </Text>
            <Button variant="ghost" onClick={() => setDrawerOpen(false)}>
              <X className="w-4 h-4" />
            </Button>
          </Flex>
          <Flex justify="center" align="center" className="mt-5 space-x-2 mx-2">
            <Input
              placeholder="Min"
              value={budgetMin}
              onChange={(e: any) => setBudgetMin(e.target.value)}
              type="number"
              className="w-32"
            />
            <Input
              placeholder="Max"
              value={budgetMax}
              onChange={(e: any) => setBudgetMax(e.target.value)}
              type="number"
              className="w-32"
            />
            <Button variant="outline" className="font-normal" onClick={clearFields}>
              Clear
            </Button>
          </Flex>
        </Flex>
        <Button className="h-10 mx-5" onClick={() => {
          filterByBidAmount();
          setDrawerOpen(false);
        }}>
          Submit
        </Button>
      </DrawerContent>
    </Drawer>
  );
}

export default BudgetFilter

